import React from 'react';
import classNames from 'classnames';
import moment from 'moment';

interface Props {
	day: string;
	date: string;
	slotAvailable: number;
	isSelected: boolean;
	setSelectedDaySlot: (value: any) => void;
	availability: any;
	startTime: any;
}

export const DateSloteCard = ({
	day,
	date,
	setSelectedDaySlot,
	slotAvailable,
	isSelected,
	availability,
	startTime,
}: Props) => {
	const isDark = true;
	return (
		<div
			className={classNames(
				'flex-shrink-0 text-center px-[16px] py-[8px] rounded-[8px] flex flex-col gap-[6px] cursor-pointer',
				isSelected
					? 'bg-[#18222D] border border-[#5a85e4] text-white'
					: 'bg-[#F2F2F5] border border-[#C7C9D9] text-black',
			)}
			onClick={() => setSelectedDaySlot(availability)}
		>
			{/* <p className="text-xs">{day}</p> */}
			<p className="text-xs">{moment(startTime).format('dddd')}</p>
			<p className={classNames({ 'leading-[21px] font-[500]': isSelected })}>{date}</p>
			<p className={classNames(isSelected && isDark ? 'text-xs text-[#05A660]' : 'text-xs text-emerald-800')}>
				{slotAvailable} Slots
			</p>
		</div>
	);
};
